import type { VariantData } from '../types';

export async function exportVariantReportAsPdf(
  element: HTMLElement,
  data: Pick<VariantData, 'gene' | 'proteinChange'>
): Promise<Blob> {
  const [{ default: html2canvas }, { jsPDF }] = await Promise.all([
    import('html2canvas'),
    import('jspdf'),
  ]);

  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    allowTaint: true,
    backgroundColor: '#ffffff',
    logging: false,
  });

  const imgData = canvas.toDataURL('image/png');
  const pdfWidth = 210;
  const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

  const pdf = new jsPDF({
    orientation: pdfHeight > pdfWidth ? 'portrait' : 'landscape',
    unit: 'mm',
    format: pdfHeight > 297 ? [pdfWidth, pdfHeight] : 'a4',
  });

  pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
  return pdf.output('blob');
}

export function variantPdfFilename(gene: string, proteinChange: string): string {
  const safe = (s: string) => s.replace(/[^a-zA-Z0-9._-]/g, '_');
  return `VarCard_${safe(gene)}_${safe(proteinChange)}.pdf`;
}
